







































































import { apiOrderWriteOffWriteOffDetail } from '@/api'
import { BookComponents } from '../components'
import { computed } from '@vue/composition-api'
import { defineClassComponent, useApi, useQuery } from '@/hooks'
import { Track } from '@/utils'

export default defineClassComponent(
  {
    components: BookComponents,
  },
  () =>
    class {
      constructor() {
        Track.useMark(() => ({
          page: '核销详情',
        }))
      }

      query = useQuery<{
        code: string
      }>()

      apiData = useApi(() =>
        apiOrderWriteOffWriteOffDetail({
          code: this.query.code,
        }),
      )

      pageData = computed(() => this.apiData.data)
    },
)
